export default __webpack_public_path__ + "static/media/NIkhil.feff435a.jpeg";